export const client = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  const androidRes = /android | adr (.*?);/
  const iosRes = /\(i[^;]+;( u;)? cpu.+mac os x/
  if (androidRes.test(userAgent)) {
    return "Android"
  } else if (iosRes.test(userAgent)) {
    return "IOS"
  } else {
    if ( /macintosh/i.test(userAgent)) {
      if('ontouchend' in document){
        return 'IPAD'
      }
      return 'MACOSX'
    }
    return "PC"
  }
}
export const isWeiXin = () => {
  const weiXinRes = /MicroMessenger/i
  return weiXinRes.test(navigator.userAgent)
}
